import { render, staticRenderFns } from "./refund-detail-user.vue?vue&type=template&id=442c4920&"
import script from "./refund-detail-user.vue?vue&type=script&lang=js&"
export * from "./refund-detail-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports